import React, { useState, useEffect } from "react";
import {
  Badge,
  Breadcrumb,
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Row,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";

import Confirm from "../Confirm";
import { Link, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import solisPowerApi from "../../api/solisPowerApi";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import FilesCreate from "../file/FilesCreate";
import RelatedListFiles from "../file/RelatedListFiles";
// import RealetedLeadTest from "./RealetedLeadTest";
// import RelatedListProjects from "../Lead/RelatedListProjects";
// import UserTracking from "./UserTracking";
// import TaskEdit from "./TaskEdit";
import Path from "../common/Path";
import ProjectPath from "../common/ProjectPath";
import moment from "moment";
import { LIST_TAB_TITLE } from "../../constants/CONSTANT";
// import * as constants from '../../constants/CONSTANT';
import Permissionhelper from "../common/Permissionhelper";
import * as constants from "../../constants/CONSTANT";
import { FaWhatsapp } from "react-icons/fa";
import PubSub from "pubsub-js";
import Chat from "../common/Chat";
import jwt_decode from "jwt-decode";
import Helmet from "react-helmet";
import Main from "../layout/Main";
import { Shimmer } from "react-shimmer";
import Image from "react-bootstrap/Image";
import RelatedSiteVisitHistory from "../siteVisit/RelatedSiteVisitHistory";
import RelatedListTask from "../task/RelatedListTask";
// import TaskEdit from "../task/TaskEdit";
import CurrencyFormatter from "currency-formatter-react";
import { disableCursor } from "@fullcalendar/core/internal";
import { ROUTES } from "../../constants/webRouting";
import {
  formatDate,
  formatDateForCreatedDate,
  getUserDetails,
  formatDateForView,
} from "../../utils/helper";
import SiteVisitModal from "../siteVisit/SiteVisitModal";
import TaskEdit from "../task/TaskEdit";
import { RelatedListOffer } from "../offer";
import PERMISSIONS from "../../constants/permissions";

const { LEAD_STATUS_VALUES, PROJECT_STATUS_VALUES } = constants;

const LeadView = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  //const course = location.state;
  const [spinner, setSpinner] = useState(true);
  const [lead, setLead] = useState(location.state ? location.state : {});
  console.log("lead data in view", lead);
  const [data, setData] = useState([]);
  const [isOverlayVisible, setIsOverlayVisible] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [showArchive, setArchiveShow] = useState(false);
  const [imageData, setImageData] = useState();
  const [modalShowFile, setModalShowFile] = useState(false);
  const [modalShowTask, setModalShowTask] = useState(false);
  const [modalShowEmail, setModalShowEmail] = useState(false);
  const [modalShowSiteVisit, setModalShowSiteVisit] = useState(false);

  const [refreshFileList, setRefreshFileList] = useState(false);
  const [refreshTaskList, setRefreshTaskList] = useState();
  const [refreshSiteVisitList, setRefreshSiteVisitList] = useState(false);
  const [refreshOfferList, setRefreshOfferList] = useState(false);
  // const [refreshLocationList, setRefreshLocationList] = useState();

  const [relatedListFiles, setRelatedListFiles] = useState(true);
  const [relatedListTaskList, setRelatedListTask] = useState(false);
  const [relatedSiteVisit, setRelatedSiteVisit] = useState(false);
  const [relatedListOrderBooking, setRelatedListOrderBooking] = useState(false);
  const [relatedListOffers, setRelatedListOffers] = useState(false);

  const [userName, setUserName] = useState("");

  const [convertShow, setConvertShow] = useState(true);

  const [showDetails, setShowDetails] = useState(true);
  const [showNotesMessages, setShowNotesMessages] = useState(false);
  const [createQuotationLoading, setCreateQuotationLoading] = useState(false);

  const [editDisable, setDisableEdit] = useState(true);
  const [payments, setPayments] = useState({});
  // const [updateCounter, setUpdateCounter] = useState(0);

  // Fixed By System on 06-Feb-2026 - Initialize with empty array fallback to prevent undefined map errors
  const [leadStatusArray, setleadStatusArray] = useState(
    constants.LEAD_STATUS_VALUES || [],
  );
  const [userInfo, setUserInfo] = useState({});
  const [proejectTotal, setTotalAmountProject] = useState({});
  const [projectLineItems, setProjectLineItems] = useState([]);

  useEffect(() => {
    let userInfoJWT = getUserDetails();
    setUserInfo(userInfoJWT);
    fetchLead();
    // console.log("Lead View", lead);
    if (userInfoJWT.id === lead.owner_id) {
      // console.log("Hello Permi");
      setDisableEdit(false);
    }
    //init();
  }, []);

  const fetchLead = () => {
    // console.log('location',location);
    console.log("Hellloo path", location.pathname.split("/").length);
    if (
      !lead.id &&
      location.hasOwnProperty("pathname") &&
      location.pathname.split("/").length >= 3
    ) {
      lead.id = location.pathname.split("/")[2];
      console.log("hahahahahahaahahahahahaahah", lead.id);
    }

    async function initStudent() {
      // console.log("lead ki id", location.state.id);
      let result = await solisPowerApi.fetchLeadById(lead.id);
      let productImageResult = false; //await solisPowerApi.fetchPrimaryImages(
      // lead.contactid
      // );
      if (productImageResult.id) {
        let productImageData = await solisPowerApi.downloadFiles(
          productImageResult.id,
          "ContactImages",
        );
        console.log("Product image data:", productImageData);

        // Convert Blob to base64 string
        let reader = new FileReader();
        reader.readAsDataURL(productImageData);
        reader.onloadend = () => {
          let base64data = reader.result;
          console.log("Base64 Product Image:", base64data);
          setImageData(base64data);
        };
      }

      if (
        result?.convertedcontactid &&
        result?.contactname &&
        result.contactname.trim().length > 0
      ) {
        ////console.log('convert call');
        setConvertShow(false);
      }
      if (result) {
        ////console.log("=======", result);

        setLead(result);
        setData(result);
        ////console.log("name : ", lead.firstname);
      } else {
        setLead({});
      }
    }
    initStudent();
  };

  useEffect(() => {
    if (!lead?.id) return;
    solisPowerApi.fetchLeadProjectLineItems(lead.id).then((rows) => {
      setProjectLineItems(Array.isArray(rows) ? rows : []);
    });
  }, [lead?.id]);

  const deleteLead = async () => {
    const result = await solisPowerApi.deleteLead(lead.id);

    if (result?.success) {
      PubSub.publish("RECORD_SAVED_TOAST", {
        title: "Deleted",
        message: "Record Deleted successfully",
      });
      navigate(ROUTES.LEAD.LIST);
    } else {
      PubSub.publish("RECORD_ERROR_TOAST", {
        title: "Record update Error",
        message: result?.errors,
      });
    }
  };

  const archiveLeads = async () => {
    lead.isarchive = true;
    const achieveLead = await solisPowerApi.saveLead(lead);
    if (achieveLead) {
      lead.lead_id = lead.id;
      const result = await solisPowerApi.createArchive(lead);
      if (result.success) {
        PubSub.publish("RECORD_SAVED_TOAST", {
          title: "Archive ",
          message: "Record Archive successfully",
        });
      }

      navigate(`/leads`);
    }
  };

  const handleMouseEnter = () => {
    setIsOverlayVisible(true);
  };

  const handleMouseLeave = () => {
    setIsOverlayVisible(false);
  };

  const edit = () => {
    navigate(`/leads/${lead.id}/e`, { state: lead });
  };

  const createProjects = () => {
    navigate("/projects/e", {
      // state: { leadView: lead.id, fromTable: "leadtable" },
      state: {
        leadView: lead.id,
        contactView: lead.contactid,
        fromTable: "leadtable",
      }, //Added by shivani 7 aug
    });
  };

  const handleSelect = (key) => {
    if (key === "files") {
      setRelatedListFiles(true);
      setRelatedListTask(false);
      setRelatedSiteVisit(false);
      setRelatedListOffers(false);
      setRelatedListOrderBooking(false);
    } else if (key === "followup") {
      setRelatedListFiles(false);
      setRelatedListTask(true);
      setRelatedSiteVisit(false);
      setRelatedListOffers(false);
      setRelatedListOrderBooking(false);
    } else if (key === "location") {
      setRelatedListFiles(false);
      setRelatedListTask(false);
      setRelatedSiteVisit(true);
      setRelatedListOffers(false);
      setRelatedListOrderBooking(false);
    } else if (key === "offers") {
      setRelatedListFiles(false);
      setRelatedListTask(false);
      setRelatedSiteVisit(false);
      setRelatedListOffers(true);
      setRelatedListOrderBooking(false);
    }
    // else if (key === "project") {
    //   setRelatedListFiles(false);
    //   setRelatedListTask(false);
    //   setRelatedSiteVisit(false);
    //   setRelatedListOffers(false);
    //   setRelatedListOrderBooking(true);
    // }
  };

  const handleSelectTab = (key) => {
    if (key === "details") {
      // setRelatedListOrderBooking(true);
      setShowDetails(true);
      setShowNotesMessages(false);
    } else if (key === "notesMessages") {
      setShowDetails(false);
      setShowNotesMessages(true);
    }
  };

  const submitFiles = () => {
    setModalShowFile(false);
    setRefreshFileList(Date.now());
    setModalShowTask(false);
    fetchLead();
  };

  const submitSiteVisit = () => {
    setModalShowSiteVisit(false);
    setRefreshSiteVisitList((prev) => !prev);
    if (lead?.id) {
      solisPowerApi.fetchLeadProjectLineItems(lead.id).then((rows) => {
        setProjectLineItems(Array.isArray(rows) ? rows : []);
      });
    }
  };
  const submitTasks = () => {
    setModalShowTask(false);
    setRefreshTaskList((prev) => !prev);
  };

  const formatAmount = (value) => {
    // Check if the value is a valid number
    if (isNaN(value)) {
      return "0";
    }

    // Convert to number and format with thousand separators
    const num = parseFloat(value); // Ensure it's a number
    return num.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const handleConvert = async () => {
    let convertStatus = "";

    let status = leadStatusArray.filter((item) => item.is_converted === true);
    //console.log("status:", status);
    convertStatus = status[0].label;
    const result = await solisPowerApi.convertLeadToContact(
      lead.id,
      convertStatus,
    );
    // console.log('result', result)
    if (result) {
      let contactId = result.convertedcontactid;
      PubSub.publish("RECORD_SAVED_TOAST", {
        title: "Lead Convert ",
        message: "Record Convert successfully",
      });
      navigate(`/contacts/${contactId}`);
      ////console.log("result.success : ", result.success);
    }
  };

  // Find the current status' sortorder
  //  const currentStatus = leadStatusArray.find(status => status.sortorder === lead.leadstatus);
  console.log("leadStatusArray", leadStatusArray);

  // Fixed By System on 06-Feb-2026 - Add safe fallback to prevent undefined map errors
  // Checking Lead Status array vallue and shwoing as till length as higlighted.
  const highlightedStatusArray = (leadStatusArray || []).map((status) => ({
    ...status,
    highlight: status.sortorder <= lead.lead_status,
  }));

  const [currentRec, setCurrentRecord] = useState({});
  const [locationRecordv1, setLocationRecordv1] = useState({});
  const [latitudev1, setLatitudev1] = useState(null);
  const [longitudev1, setLongitudev1] = useState(null);
  console.log("lead value", lead);
  const [addressv1, setAddressv1] = useState(
    `${lead.street} ${lead.state} ${lead.zipcode}`,
  ); // Default address
  const [buttonDisabledv1, setButtonDisabledv1] = useState(false);
  const [remarksv1, setRemarksv1] = useState("");

  useEffect(() => {
    const loadGoogleMapsScript = () => {
      if (!window.google) {
        const googleMapScript = document.createElement("script");
        googleMapScript.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyC_62P9eUo4w05IfwuHdnUiQRO1mPFT1CM&callback=initMap`;
        googleMapScript.async = true;
        googleMapScript.defer = true;
        googleMapScript && window.document.body.appendChild(googleMapScript);
      } else {
        window.initMap();
      }
    };

    window.initMap = () => {
      myMapFunction();
    };

    loadGoogleMapsScript();
  }, [latitudev1, longitudev1, addressv1]);

  const myMapFunction = async () => {
    if (!latitudev1 || !longitudev1) {
      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({ address: addressv1 }, (results, status) => {
        if (status === "OK") {
          const location = results[0].geometry.location;
          setLatitudev1(location.lat());
          setLongitudev1(location.lng());

          const mapProp = {
            center: location,
            zoom: 14,
          };

          const map = new window.google.maps.Map(
            document.getElementById("googleMapaddress"),
            mapProp,
          );

          const marker = new window.google.maps.Marker({
            map,
            position: location,
            title: results[0].formatted_address,
          });

          const infowindow = new window.google.maps.InfoWindow({
            content: results[0].formatted_address,
          });

          marker.addListener("click", () => {
            infowindow.open(map, marker);
          });

          setAddressv1(results[0].formatted_address);
        } else {
          console.error(
            "Geocode was not successful for the following reason: " + status,
          );
        }
      });
    } else {
      const location = new window.google.maps.LatLng(latitudev1, longitudev1);
      const mapProp = {
        center: location,
        zoom: 14,
      };

      const map = new window.google.maps.Map(
        document.getElementById("googleMapaddress"),
        mapProp,
      );

      const marker = new window.google.maps.Marker({
        map,
        position: location,
        title: addressv1,
      });

      const infowindow = new window.google.maps.InfoWindow({
        content: addressv1,
      });

      marker.addListener("click", () => {
        infowindow.open(map, marker);
      });
    }
  };

  const handleWhatsAppClick = () => {
    // Create the WhatsApp URL using the phone number from the lead object
    const whatsappUrl = `https://wa.me/${lead.phone}`;
    window.location.href = whatsappUrl; // Redirect to WhatsApp chat
  };

  // this code use for project details and address information  accordion start here
  const [openProject, setOpenProject] = useState(null);

  const toggleProject = (index) => {
    setOpenProject(openProject === index ? null : index);
  };

  const projects = lead?.projects?.length ? lead.projects : [lead];
  const informationDetailsRows =
    projectLineItems?.length > 0 ? projectLineItems : [lead];

  // this code use for project details and address information  accordion end here

  return (
    <Container className="pb-5">
      {lead && (
        <>
          {modalShow && (
            <Confirm
              show={modalShow}
              onHide={() => setModalShow(false)}
              deleteLead={deleteLead}
              title="Confirm delete?"
              message="You are going to delete the record. Are you sure?"
              table="lead"
            />
          )}

          {showArchive && (
            <Confirm
              show={showArchive}
              onHide={() => setArchiveShow(false)}
              archiveLeads={archiveLeads}
              title="Confirm Archive?"
              message="You are going to Archive the record. Are you sure?"
              table="archive"
            />
          )}

          <Row className="view-form   mx-auto">
            <Col md={12} className="">
              <Breadcrumb>
                <Breadcrumb.Item onClick={() => navigate(ROUTES.HOME)}>
                  Home
                </Breadcrumb.Item>
                <Breadcrumb.Item onClick={() => navigate(ROUTES.LEAD.LIST)}>
                  Leads
                </Breadcrumb.Item>
              </Breadcrumb>
            </Col>

            <Col lg={12} className="">
              <Container className="pb-3 sticky-card-header-view">
                <Row className="view-form-header-lead bg-custom align-items-center rounded  ">
                  <Col lg={6}>
                    Lead
                    <h5>{lead.lead_name || ""}</h5>
                  </Col>
                  <Col
                    lg={6}
                    className="d-flex justify-content-end  social-icon"
                  >
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip className="my-tooltip">Call</Tooltip>}
                    >
                      <Button
                        className="btn-sm"
                        href={`tel:${lead.phone}`}
                        variant="danger"
                      >
                        <i class="fa fa-phone"></i>
                      </Button>
                    </OverlayTrigger>
                    <OverlayTrigger
                      placement="top"
                      show={isOverlayVisible} // Controls visibility of overlay
                      overlay={
                        <Tooltip className="my-tooltip">
                          Chat on WhatsApp
                        </Tooltip>
                      }
                    >
                      <Button
                        variant="success"
                        onClick={handleWhatsAppClick}
                        className="btn-sm whatsapp-btn"
                      >
                        <FaWhatsapp size={20} style={{ marginRight: 8 }} />
                        WhatsApp
                      </Button>
                    </OverlayTrigger>

                    {/* Fixed By System on 06-Feb-2026 - Add fallback empty array to prevent undefined map errors */}
                    {[PERMISSIONS.MODIFY_ALL, PERMISSIONS?.MODIFY_LEAD].some(
                      (permission) => {
                        return (userInfo?.permissions || [])
                          .map((p) => p.name)
                          .includes(permission);
                      },
                    ) && (
                        <Button
                          size="sm"
                          className="btn-edit"
                          onClick={() => edit(true)}
                        >
                          <i className="fa-regular fa-pen-to-square"></i>
                        </Button>
                      )}

                    {[PERMISSIONS.DELETE_ALL, PERMISSIONS?.DELETE_LEAD].some(
                      (permission) => {
                        return (userInfo?.permissions || [])
                          .map((p) => p.name)
                          .includes(permission);
                      },
                    ) && (
                        <Button
                          size="sm"
                          className="btn-delete"
                          onClick={() => setModalShow(true)}
                        >
                          <i className="fa fa-trash-o"></i>
                        </Button>
                      )}

                    <Button
                      size="sm"
                      // className="btn-edit"
                      variant="warning"
                      onClick={() => setModalShowSiteVisit(true)}
                      className="createsitevisit"
                    >
                      Create Site Visit
                    </Button>

                    {/* Create Quotation - always visible; updates lead status to Quotation without Site Visit on click */}
                    <Button
                      size="sm"
                      variant="success"
                      disabled={!lead?.id || createQuotationLoading}
                      onClick={async () => {
                        if (!lead?.id || createQuotationLoading) return;
                        setCreateQuotationLoading(true);
                        try {
                          const statusPayload = { id: lead.id, lead_status: "Quotation without Site Visit" };
                          const result = await solisPowerApi.saveLead(statusPayload);
                          if (result?.success) {
                            setLead((prev) => (prev ? { ...prev, lead_status: "Quotation without Site Visit" } : prev));
                          } else if (result?.errors) {
                            PubSub.publish("RECORD_ERROR_TOAST", {
                              title: "Status Update",
                              message: result.errors || "Failed to update lead status",
                            });
                          }
                        } catch (err) {
                          console.warn("Lead status update before quotation:", err);
                          PubSub.publish("RECORD_ERROR_TOAST", {
                            title: "Status Update",
                            message: err?.response?.data?.errors || "Failed to update lead status",
                          });
                        } finally {
                          setCreateQuotationLoading(false);
                        }
                        navigate(`/quotations/e?lead_id=${lead.id}`);
                      }}
                      className="create-quotation-btn"
                      style={{ marginLeft: "8px" }}
                    >
                      <i className="fa fa-file-text me-1"></i> Create Quotation
                    </Button>
                  </Col>
                </Row>
              </Container>
              <Card>
                <CardHeader className="sticky-tabs-header py-3">
                  <Col lg={12} className="" style={{ color: "#fff" }}>
                    <Tabs
                      defaultActiveKey="details"
                      id="uncontrolled-tab-example"
                      onSelect={(key) => handleSelectTab(key)}
                      style={{ marginBottom: "12px" }}
                    >
                      <Tab eventKey="details" title="Details"></Tab>
                      <Tab
                        eventKey="notesMessages"
                        title="Notes & Messages"
                      ></Tab>
                    </Tabs>
                  </Col>
                </CardHeader>

                <CardBody className="card-body-scroll">
                  <Container>
                    {showDetails && (
                      <Row className="  ">
                        {/* <Col lg={12}>
                          <div className="scrollable-container">
                            <Path
                              values={highlightedStatusArray}
                              selectedValue={lead.lead_status}
                            />
                          </div>
                        </Col> */}
                        <>
                          <Col lg={6}>
                            <label>Lead No</label>
                            <span>{lead.lead_no}</span>
                          </Col>

                          <Col lg={6}>
                            <label>Lead Name</label>
                            <span>{lead.lead_name || ""}</span>
                          </Col>

                          {lead?.lead_status === "Hold" && (
                            <Col lg={6}>
                              <label>Hold Reason</label>
                              <span>{lead.hold_reason}</span>
                            </Col>
                          )}
                          {lead?.hold_reason === "Delay" && (
                            <Col lg={6}>
                              <label>Delay Reason</label>
                              <span>{lead.delay_reason}</span>
                            </Col>
                          )}

                          <Col lg={6}>
                            <label>Email</label>
                            <span>{lead.email}</span>
                          </Col>

                          <Col lg={6}>
                            <label>Phone</label>
                            <span>{lead.phone}</span>
                          </Col>

                          <Col lg={6}>
                            <label>WhatsApp Number</label>
                            <span>{lead.whatsapp_no}</span>
                          </Col>
                          <Col lg={6}>
                            <label>Background</label>
                            <span>{lead.background}</span>
                          </Col>

                          {/* <Col lg={6}>
                            <label>Reference</label>
                            <span>
                              {lead.accounts
                                ?.map((item) => item.label)
                                ?.join(",") || ""}
                            </span>
                          </Col> */}

                          <Col lg={6}>
                            <label>Lead Source</label>
                            <span>{lead.leadsource}</span>
                          </Col>

                          {/* <Col lg={6}>
                            <label>Referred By</label>
                            <span>{lead.contact_name}</span>
                          </Col> */}
                          <Col lg={6}>
                            <label>Assigned Users</label>
                            <span>
                              <div className="d-flex flex-wrap gap-1">
                                {/* Fixed By System on 06-Feb-2026 - Add fallback empty array to prevent undefined map errors */}
                                {(lead?.owner_ids || []).map((item) => (
                                  <Badge
                                    key={item.value || item.label}
                                    bg="warning"
                                  // className="mx-2"
                                  // style={{ display: "inline", color: "#000" }}
                                  >
                                    <Link
                                      to={
                                        userInfo.id === item.value
                                          ? `${ROUTES.USER.LIST}/${item.value}`
                                          : ""
                                      }
                                      className="text-decoration-none text-dark fw-bold"
                                    >
                                      {item.label}
                                    </Link>
                                  </Badge>
                                ))}
                                {(!lead?.owner_ids ||
                                  lead.owner_ids.length === 0) && (
                                    <span className="text-muted">
                                      No assigned users
                                    </span>
                                  )}
                              </div>
                            </span>
                          </Col>

                          <Col lg={6}>
                            <label>Address</label>
                            <span>{lead.customer_address || ""}</span>
                          </Col>
                          <Col lg={6}>
                            <label>Area</label>
                            <span>{lead.customer_area || ""}</span>
                          </Col>
                          <Col lg={6}>
                            <label>State</label>
                            <span>{lead.customer_state || ""}</span>
                          </Col>
                          <Col lg={6}>
                            <label>City</label>
                            <span>{lead.customer_city || ""}</span>
                          </Col>
                          <Col lg={6}>
                            <label>Pincode</label>
                            <span>{lead.customer_pincode || ""}</span>
                          </Col>

                          <Col lg={6}>
                            <label>Created Date</label>
                            <span>
                              {formatDateForView(lead?.createddate || "")}
                            </span>
                          </Col>
                        </>

                        {/* <>
                          <Col md={12} className="section-header">
                            Service Information
                          </Col>

                          <Col lg={6}>
                            <label>Product</label>
                            <span>{lead.product_name}</span>
                          </Col>

                          <Col lg={6}>
                            <label>Quantity</label>
                            <span>{lead.qty}</span>
                          </Col>

                       

                          {imageData && (
                            <Image
                              style={{
                                height: "70px",
                                width: "80px",
                              }}
                              src={imageData}
                              fluid
                              alt="No Image Found"
                            />
                          )}
                        </> */}

                        <>
                          {/* this code use for project details and address information start here */}
                          {projectLineItems &&
                            Array.isArray(projectLineItems) &&
                            projectLineItems.length > 0 &&
                            projectLineItems.some(
                              (p) =>
                                p &&
                                Object.values(p).some(
                                  (v) => v !== null && v !== "" && String(v).trim() !== ""
                                )
                            ) && (
                              <div className="accordion-container">
                                <div className="container">
                                  {/* Projects */}
                                  <div className="card">
                                    <div className="card-header">
                                      PROJECT DETAILS
                                    </div>
                                    {informationDetailsRows.map((row, index) => (
                                      <div key={row.id != null ? row.id : index} className="projects-wrapper">
                                        <div className="project-card">
                                          <div
                                            className="project-header"
                                            onClick={() => toggleProject(index)}
                                          >
                                            <div>
                                              <h3>Project {index + 1} : {row.site_name}</h3>
                                            </div>
                                            <button className="toggle-btn btn-sm whatsapp-btn btn btn-success">
                                              {openProject === index
                                                ? "Hide Details"
                                                : "View Details"}
                                            </button>
                                          </div>

                                          {openProject === index && (
                                            <div className="project-body">
                                              <div className="section-block">
                                                <h4>Project Details</h4>
                                                {(PROJECT_STATUS_VALUES || []).length > 0 && (
                                                  <div className="mb-3 scrollable-container">
                                                    <ProjectPath
                                                      values={PROJECT_STATUS_VALUES}
                                                      selectedValue={row.project_status || ""}
                                                    />
                                                  </div>
                                                )}
                                                <div className="grid-2">
                                                  <div>
                                                    <label>Site Name</label>
                                                    <span>{row.site_name}</span>
                                                  </div>
                                                  <div>
                                                    <label>Lead Type</label>
                                                    <span>{row.leadtype}</span>
                                                  </div>
                                                  <div>
                                                    <label>Project Status</label>
                                                    <span>{row.project_status || "-"}</span>
                                                  </div>
                                                  <div>
                                                    <label>
                                                      On-site Contact Person No
                                                    </label>
                                                    <span>
                                                      {
                                                        row.on_site_contact_person_no
                                                      }
                                                    </span>
                                                  </div>

                                                  <div>
                                                    <label>No of Floors</label>
                                                    <span>{row.no_of_floors}</span>
                                                  </div>

                                                  <div>
                                                    <label>Type of Floors</label>
                                                    <span>{row.type_of_roof}</span>
                                                  </div>

                                                  <div>
                                                    <label>Module Type</label>
                                                    <span>{row.dcr}</span>
                                                  </div>

                                                  <div>
                                                    <label>
                                                      Plant Capacity Required By
                                                      Client
                                                    </label>
                                                    <span>
                                                      {
                                                        row.plant_capacity_required_by_client
                                                      }
                                                    </span>
                                                  </div>

                                                  <div>
                                                    <label>
                                                      Type of Connection
                                                    </label>
                                                    <span>
                                                      {row.type_of_connection}
                                                    </span>
                                                  </div>

                                                  <div>
                                                    <label>Sanction Load</label>
                                                    <span>
                                                      {row.sanction_load}
                                                    </span>
                                                  </div>

                                                  <div>
                                                    <label>
                                                      Connection Modification
                                                    </label>
                                                    <span>
                                                      {row.connection_modification}
                                                    </span>
                                                  </div>

                                                  <div>
                                                    <label>
                                                      Type Of Modification
                                                    </label>
                                                    <span>
                                                      {
                                                        row.connection_modification_applicable
                                                      }
                                                    </span>
                                                  </div>

                                                  <div>
                                                    <label>
                                                      Average Monthly Bill
                                                    </label>
                                                    <span>
                                                      {row.average_monthly_bill}
                                                    </span>
                                                  </div>

                                                  <div>
                                                    <label>Type Of Project</label>
                                                    <span>
                                                      {row.type_of_project}
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>

                                              <div className="section-block">
                                                <h4>Address Information</h4>
                                                <div className="grid-2">
                                                  <div>
                                                    <label>Location Link</label>
                                                    <span>
                                                      {row.location_link}
                                                    </span>
                                                    <a
                                                      href={
                                                        row.location_link
                                                          ? row.location_link
                                                          : disableCursor
                                                      }
                                                      target="_blank"
                                                      rel="noopener noreferrer"
                                                    >
                                                      View Map
                                                    </a>
                                                  </div>
                                                  <div>
                                                    <label>Address</label>
                                                    <span>{row.address}</span>
                                                  </div>
                                                  <div>
                                                    <label>State</label>
                                                    <span>{row.state}</span>
                                                  </div>
                                                  <div>
                                                    <label>City</label>
                                                    <span>{row.city}</span>
                                                  </div>
                                                  <div>
                                                    <label>Country</label>
                                                    <span>{row.country}</span>
                                                  </div>
                                                  {row.pincode != null && row.pincode !== "" && (
                                                    <div>
                                                      <label>Pincode</label>
                                                      <span>{row.pincode}</span>
                                                    </div>
                                                  )}
                                                  {/* <div>
                                              <div
                                                id="googleMapaddress"
                                                className="my-2"
                                                style={{
                                                  width: "100%",
                                                  height: "300px",
                                                  border: "1px solid black",
                                                }}
                                              ></div>
                                            </div> */}
                                                </div>

                                                <div className="map-container">
                                                  <iframe
                                                    id="googleMapaddress"
                                                    // src="https://www.google.com/maps?q=Ajmer,Rajasthan&output=embed"
                                                    title="map1"
                                                  />
                                                </div>
                                              </div>
                                              {row.lead_status === "Lost" && (
                                                <div className="section-block">
                                                  <h4>LOST LEAD INFORMATION</h4>
                                                  <div className="grid-2">
                                                    <div>
                                                      <label>Lost Date</label>
                                                      <span>
                                                        {formatDateForCreatedDate(
                                                          lead?.is_lost_date || "",
                                                        )}
                                                      </span>
                                                    </div>
                                                    <div>
                                                      <label>
                                                        Lead Lost Remark
                                                      </label>
                                                      <span>
                                                        {lead.lead_lost_remark}
                                                      </span>
                                                    </div>
                                                    <div>
                                                      <label>
                                                        Lost By (Company)
                                                      </label>
                                                      <span>
                                                        {lead.lost_by_reason}
                                                      </span>
                                                    </div>
                                                  </div>
                                                </div>
                                              )}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              </div>
                            )}
                          {/* this code use for project details and address information end here */}


                        </>

                        {/* <>
                          <Col md={12} className="section-header">
                            Enquiry Information
                          </Col>

                          <Col lg={6}>
                            <label>Offer</label>
                            <span>{lead.offer_name}</span>
                          </Col>

                          <Col lg={6}>
                            <label>Time Slot</label>
                            <span>{lead.time_slot}</span>
                          </Col>
                          <Col lg={6}>
                            <label>Customer Site Visit Date</label>
                            <span>{formatDateForView(lead?.customer_site_visit_date || "")}</span>
                          </Col>
                          <Col lg={12}>
                            <label>Enquiry Remark</label>
                            <span>{lead.enquiry_remark}</span>
                          </Col>
                        </> */}

                        {lead.lead_status === "Lost" && (
                          <>
                            <Col lg={12} className="section-header">
                              LOST LEAD INFORMATION
                            </Col>
                            <Col lg={6}>
                              <label>Lost Date</label>
                              <span>
                                {formatDateForCreatedDate(
                                  lead?.is_lost_date || "",
                                )}
                              </span>
                            </Col>
                            <Col lg={6}>
                              <label>Lead Lost Remark</label>
                              <span>{lead.lead_lost_remark}</span>
                            </Col>
                            <Col lg={6}>
                              <label>Lost By (Company)</label>
                              <span>{lead.lost_by_reason}</span>
                            </Col>
                          </>
                        )}
                      </Row>
                    )}

                    {showNotesMessages && (
                      <Card className="mt-2">
                        <Row className="mt-4">
                          <Col lg={12}>
                            <Chat parentid={lead.id} />
                          </Col>
                        </Row>
                      </Card>
                    )}
                  </Container>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Card bg="light" text="light" className="mb-2 mt-4 shadow">
            <Card.Header className="site-visit-card">
              <Tabs
                defaultActiveKey="files"
                id="uncontrolled-tab-example"
                onSelect={(key) => handleSelect(key)}
              >
                {/* Fixed By System on 06-Feb-2026 - Add fallback empty array to prevent undefined map errors */}
                {[PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_FILE].some(
                  (permission) => {
                    return (userInfo?.permissions || [])
                      .map((p) => p.name)
                      .includes(permission);
                  },
                ) && <Tab eventKey="files" title="Files"></Tab>}
                {/* {[PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_TASK].some(permission => {
                  return userInfo?.permissions?.map(p => p.name).includes(permission);
                }) &&
                  <Tab eventKey="followup" title="Follow Up"></Tab>
                } */}
                {/* Fixed By System on 06-Feb-2026 - Add fallback empty array to prevent undefined map errors */}
                {[PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_SITE_VISIT].some(
                  (permission) => {
                    return (userInfo?.permissions || [])
                      .map((p) => p.name)
                      .includes(permission);
                  },
                ) && (
                    <Tab
                      eventKey="location"
                      title="Site Visit Location History"
                    ></Tab>
                  )}
                {/* Fixed By System on 06-Feb-2026 - Add fallback empty array to prevent undefined map errors */}
                {[PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_TASK].some(
                  (permission) => {
                    return (userInfo?.permissions || [])
                      .map((p) => p.name)
                      .includes(permission);
                  },
                ) && <Tab eventKey="followup" title="Tasks/Follow-Up"></Tab>}
              </Tabs>

              {/* Buttons */}
              {/* Fixed By System on 06-Feb-2026 - All permission checks already use optional chaining safely */}
              {relatedListFiles &&
                [PERMISSIONS.MODIFY_ALL, PERMISSIONS?.MODIFY_FILE].some(
                  (permission) => {
                    return (userInfo?.permissions || [])
                      .map((p) => p.name)
                      .includes(permission);
                  },
                ) && (
                  <Button
                    size="sm"
                    className="btn-custom float-right"
                    onClick={() => setModalShowFile(true)}
                  >
                    New File
                  </Button>
                )}

              {relatedListTaskList &&
                [PERMISSIONS.MODIFY_ALL, PERMISSIONS?.MODIFY_TASK].some(
                  (permission) => {
                    return (userInfo?.permissions || [])
                      .map((p) => p.name)
                      .includes(permission);
                  },
                ) && (
                  <Button
                    size="sm"
                    className="btn-custom float-right"
                    onClick={() => setModalShowTask(true)}
                  >
                    New Follow Up/Task
                  </Button>
                )}

              {relatedSiteVisit &&
                [PERMISSIONS.MODIFY_ALL, PERMISSIONS?.MODIFY_SITE_VISIT].some(
                  (permission) => {
                    return (userInfo?.permissions || [])
                      .map((p) => p.name)
                      .includes(permission);
                  },
                ) && (
                  <Button
                    size="sm"
                    className="btn-custom float-right"
                    onClick={() => setModalShowSiteVisit(true)}
                  >
                    New Site Visit
                  </Button>
                )}

              {/* Modals */}
              {modalShowFile && (
                <FilesCreate
                  show={modalShowFile}
                  onHide={() => setModalShowFile(false)}
                  parent={lead}
                  table="medicaltest"
                  submitFiles={submitFiles}
                />
              )}

              {modalShowTask && (
                <TaskEdit
                  show={modalShowTask}
                  onHide={() => setModalShowTask(false)}
                  parentid={lead?.id}
                  table="lead"
                  submitTasks={submitTasks}
                />
              )}

              {modalShowSiteVisit && (
                <SiteVisitModal
                  show={modalShowSiteVisit}
                  onHide={() => setModalShowSiteVisit(false)}
                  parent={lead}
                  submitSiteVisit={submitSiteVisit}
                />
              )}
            </Card.Header>
            <Card.Body>
              {/* File related List */}
              {/* Fixed By System on 06-Feb-2026 - Add fallback empty array to prevent undefined map errors */}
              {relatedListFiles &&
                [PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_FILE].some(
                  (permission) => {
                    return (userInfo?.permissions || [])
                      .map((p) => p.name)
                      .includes(permission);
                  },
                ) && (
                  <RelatedListFiles
                    refreshFileList={refreshFileList}
                    // onFileUpdate={updateCounter}
                    parent={lead}
                    submitFiles={submitFiles} //Added by shivani
                  />
                )}

              {/* Task related List */}
              {relatedListTaskList &&
                [PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_TASK].some(
                  (permission) => {
                    return (userInfo?.permissions || [])
                      .map((p) => p.name)
                      .includes(permission);
                  },
                ) && (
                  <RelatedListTask
                    refreshTaskList={refreshTaskList}
                    parent={lead}
                    submitFiles={submitTasks}
                    table="Lead"
                  />
                )}

              {/* Site visit related List */}
              {relatedSiteVisit &&
                [PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_SITE_VISIT].some(
                  (permission) => {
                    return (userInfo?.permissions || [])
                      .map((p) => p.name)
                      .includes(permission);
                  },
                ) && (
                  <RelatedSiteVisitHistory
                    refreshSiteVisitList={refreshSiteVisitList}
                    parent={lead}
                  />
                )}

              {/* Offer related List */}
              {relatedListOffers &&
                [PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_OFFER].some(
                  (permission) => {
                    return (userInfo?.permissions || [])
                      .map((p) => p.name)
                      .includes(permission);
                  },
                ) && (
                  <RelatedListOffer
                    refreshOfferList={refreshOfferList}
                    lead={lead}
                  />
                )}
            </Card.Body>
          </Card>
        </>
      )}
    </Container>
  );
};
export default LeadView;